/** 각인 이름 → 아이콘 경로 매핑 (lostarkcodex.com 기반) */
export const ENGRAVING_ICONS: Record<string, string> = {
  "약자 무시": "/engraving-icons/achieve_04_30.webp",
  "정기 득수": "/engraving-icons/buff_65.webp",
  "에테르 포식자": "/engraving-icons/buff_74.webp",
  "안정된 상태": "/engraving-icons/buff_105.webp",
  "원한": "/engraving-icons/buff_71.webp",
  "슈퍼 차지": "/engraving-icons/achieve_06_14.webp",
  "굳은 의지": "/engraving-icons/buff_44.webp",
  "구실동자": "/engraving-icons/buff_18.webp",
  "위기 모면": "/engraving-icons/buff_162.webp",
  "예리한 뒷기": "/engraving-icons/achieve_03_40.webp",
  "급소 타격": "/engraving-icons/buff_168.webp",
  "최대 마나 증가": "/engraving-icons/buff_122.webp",
  "마나 효율 증가": "/engraving-icons/buff_166.webp",
  "달의 저격": "/engraving-icons/buff_89.webp",
  "탈출의 명수": "/engraving-icons/buff_10.webp",
  "불굴": "/engraving-icons/buff_66.webp",
  "분노의 주먹": "/engraving-icons/buff_83.webp",
  "실드관통": "/engraving-icons/buff_89.webp",
  "여신의 가호": "/engraving-icons/buff_46.webp",
  "폭발물 전문가": "/engraving-icons/buff_121.webp",
  "강화 방패": "/engraving-icons/buff_239.webp",
  "강령술": "/engraving-icons/buff_29.webp",
  "선수필승": "/engraving-icons/achieve_08_62.webp",
  "부러진 뼈": "/engraving-icons/buff_94.webp",
  "벌개의 분노": "/engraving-icons/buff_191.webp",
  "저주받은 인형": "/engraving-icons/buff_237.webp",
  "승부사": "/engraving-icons/buff_136.webp",
  "기습의 대가": "/engraving-icons/buff_148.webp",
  "마나의 흐름": "/engraving-icons/buff_63.webp",
  "바리케이드": "/engraving-icons/buff_170.webp",
  "돌격대장": "/engraving-icons/buff_210.webp",
  "척성": "/engraving-icons/buff_113.webp",
  "결투의 대가": "/engraving-icons/ability_224.webp",
  "질량 증가": "/engraving-icons/ability_231.webp",
  "추진력": "/engraving-icons/ability_232.webp",
  "타격의 대가": "/engraving-icons/ability_233.webp",
  "시선 집중": "/engraving-icons/ability_235.webp",
  "아드레날린": "/engraving-icons/ability_236.webp",
  "속전속결": "/engraving-icons/ability_237.webp",
  "긴급구조": "/engraving-icons/ability_238.webp",
  "정밀 단도": "/engraving-icons/ability_239.webp",
  "광기": "/engraving-icons/ability_270.webp",
  "광전사의 비기": "/engraving-icons/ability_269.webp",
  "강화 무기": "/engraving-icons/ability_242.webp",
  "화력 강화": "/engraving-icons/buff_600.webp",
  "포격 강화": "/engraving-icons/gl_skill_01_26.webp",
  "전투 태세": "/engraving-icons/ability_266.webp",
  "고독한 기사": "/engraving-icons/ability_267.webp",
  "오의 강화": "/engraving-icons/buff_238.webp",
  "초심": "/engraving-icons/ability_25.webp",
  "극의: 찬술": "/engraving-icons/achieve_07_22.webp",
  "충격 단련": "/engraving-icons/buff_177.webp",
  "진실된 용맥": "/engraving-icons/ability_275.webp",
  "절실한 구원": "/engraving-icons/ability_276.webp",
  "분노의 망치": "/engraving-icons/ability_268.webp",
  "중력 수련": "/engraving-icons/ability_268.webp",
  "상급 소환사": "/engraving-icons/buff_78.webp",
  "넘치는 교감": "/engraving-icons/ability_274.webp",
  "황후의 은총": "/engraving-icons/ability_272.webp",
  "황제의 칙령": "/engraving-icons/ability_273.webp",
  "세맥타통": "/engraving-icons/ability_45.webp",
  "역천지계": "/engraving-icons/ability_47.webp",
  "두 번째 동료": "/engraving-icons/buff_245.webp",
  "죽음의 습격": "/engraving-icons/ability_258.webp",
  "절정": "/engraving-icons/ability_207.webp",
  "절제": "/engraving-icons/ability_208.webp",
  "잔재된 기운": "/engraving-icons/ability_209.webp",
  "버스트": "/engraving-icons/ability_210.webp",
  "완벽한 억제": "/engraving-icons/ability_211.webp",
  "끼어나올 수 없는 충동": "/engraving-icons/ability_212.webp",
  "심판자": "/engraving-icons/ability_214.webp",
  "축복의 오라": "/engraving-icons/ability_215.webp",
  "아르데타인의 기술": "/engraving-icons/ability_216.webp",
  "진화의 유산": "/engraving-icons/ability_217.webp",
  "갈증": "/engraving-icons/ability_222.webp",
  "달의 소리": "/engraving-icons/ability_223.webp",
  "피스메이커": "/engraving-icons/ability_225.webp",
  "사랑의 시간": "/engraving-icons/ability_228.webp",
  "일격필살": "/engraving-icons/ability_45.webp",
  "오의난무": "/engraving-icons/ability_229.webp",
  "점화": "/engraving-icons/ability_240.webp",
  "환려": "/engraving-icons/ability_241.webp",
  "회귀": "/engraving-icons/ability_248.webp",
  "만개": "/engraving-icons/ability_249.webp",
  "질풍노도": "/engraving-icons/ability_259.webp",
  "이슬비": "/engraving-icons/ability_260.webp",
  "포식자": "/engraving-icons/ability_261.webp",
  "처단자": "/engraving-icons/ability_263.webp",
  "만월의 집행자": "/engraving-icons/ability_264.webp",
  "그빠의 경계": "/engraving-icons/ability_266.webp",
  "권왕파천무": "/engraving-icons/ability_277.webp",
  "수라의 길": "/engraving-icons/ability_278.webp",
};
